import { makeStyles, tokens } from "@fluentui/react-components";
import { flexChildSizeFixed, flexParent, textClip } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
// Minimum width for the menu popover
const menuPopoverMinWidth = "180px";
/**
 * Styles for ConnectedPlansButton
 */ export const useConnectedPlansButtonStyles = makeStyles({
    button: {
        ...flexChildSizeFixed(),
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightRegular,
        borderRadius: tokens.borderRadiusXLarge,
        color: tokens.colorNeutralForeground2,
        "&:focus-visible, &[data-fui-focus-visible]": {
            outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
            outlineOffset: `calc(${tokens.strokeWidthThick} * -1)`
        }
    },
    menuPopover: {
        minWidth: menuPopoverMinWidth,
        borderRadius: tokens.borderRadiusXLarge
    },
    headerItem: {
        fontSize: tokens.fontSizeBase200,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground2
    },
    connectedTaskItem: {
        ...flexParent(),
        ...textClip("ellipsis"),
        "&:focus-visible, &[data-fui-focus-visible]": {
            outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
            outlineOffset: `calc(${tokens.strokeWidthThick} * -1)`
        }
    },
    connectedTaskItemContent: {
        ...textClip("ellipsis")
    },
    menuItemLabel: {
        ...textClip("ellipsis"),
        display: "block",
        minWidth: 0,
        width: "100%"
    }
});
